import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  PortalBookingStatusTypeEnum,
  PortalLeadNode,
  PortalOrderQuoteCardNode,
} from '@app/services/api/api.types';
import { getOptionSoldAmount } from '@app/utils/utils';

@Component({
  selector: 'portal-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionComponent {
  PortalBookingStatusTypeEnum = PortalBookingStatusTypeEnum;

  @Input() option: PortalOrderQuoteCardNode;
  @Input() portalLead?: PortalLeadNode;
  @Input() portalLink: string;
  @Input() isPresentation: boolean;
  @Input() withHiddenFlightsV2: boolean;
  @Input() isLeastExpensive: boolean;
  // Disables the request-to-book button while ``LeadPageComponent`` fetches
  // the full ``portalOrder`` for this option — see TIC-6859 payload split.
  @Input() isSubmitting: boolean;

  @Output() requestToBook = new EventEmitter();

  getOptionSoldAmount = getOptionSoldAmount;
}
